import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

import {
  PAGE_TYPES,
  APPLICATION_IDS
} from '@thebeansgroup/js-shared-utils/constants'
import { getGlobalContexts } from '@thebeansgroup/js-shared-utils/helpers'
import ThirdPartyTracking from '@thebeansgroup/third_party_tracking'

import {
  handleConsentChanged,
  oneTrustOnConsentChanged
} from '@helpers/cookie_consents'
import { getThirdPartyConfig } from '@helpers/third_party_tracking'
import { useCountryCode } from '@hooks/use_country_code'
import { useIsSnowplowSetup } from '@hooks/use_is_snowplow_setup'
import useUserProfile from '@hooks/use_user_profile'
import { setupSnowplow, trackPageView } from '@tracker/snowplow'

import { thirdPartyTrackingPageView, getCustomContexts } from './helpers'

const PageView = ({ customContexts, pageType, title }) => {
  const { userProfile, loading } = useUserProfile()
  const country = useCountryCode()
  const { isSnowplowSetup } = useIsSnowplowSetup()

  useEffect(() => {
    if (!loading) {
      const globalContexts = getGlobalContexts(
        APPLICATION_IDS.beansidMarketplace,
        pageType,
        country,
        userProfile
      )
      setupSnowplow(null, globalContexts)
    }
  }, [pageType, country, userProfile, loading])

  useEffect(() => {
    if (isSnowplowSetup) {
      const pixelDedupeUid = uuidv4()
      const pathName = window.location.pathname
      const contexts = getCustomContexts(
        customContexts,
        pixelDedupeUid,
        null,
        pathName
      )
      trackPageView(title || document.title, contexts)
      ThirdPartyTracking.init(null, getThirdPartyConfig())
      thirdPartyTrackingPageView(pageType, pixelDedupeUid, pathName)
      oneTrustOnConsentChanged(() => handleConsentChanged(contexts))
    }
  }, [customContexts, pageType, isSnowplowSetup, title])

  return null
}

PageView.propTypes = {
  customContexts: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageType: PropTypes.oneOf(Object.values(PAGE_TYPES)).isRequired,
  title: PropTypes.string
}

PageView.defaultProps = {
  customContexts: [],
  title: ''
}

export default PageView
